import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalContent"]
  static values = {
    url: String
  }

  connect() {
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    // Clean up event listener
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  open(event) {
    // Get the value from the trigger
    this.currentUrl = event.target.dataset.modalUrlValue;
    console.log("Current URL for modal:", this.currentUrl);
    this.modalContentTarget.src = this.currentUrl
    // Show the modal
    this.modalTarget.classList.remove("hidden");

    // You can now use this.currentUrl wherever you need it in the controller
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalContentTarget.innerHTML = ""
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.close()
    }
  }
} 
